module.exports = __webpack_public_path__ + "img/zxsb-icon.9515bb77.png";